import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useServices } from 'index';
import { AdminModule } from 'types/admin/modulesV2';

type Callbacks = {
  onMutate?: () => void;
  onSuccess?: () => Promise<void> | void;
  onSettled?: () => void;
};

export const useUpdateModuleV2 = (moduleId: string, callbacks?: Callbacks) => {
  const service = useServices().moduleListV2Service;
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (module: AdminModule) => service.updateModule(module),
    onMutate: callbacks?.onMutate,
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['adminModuleListV2'] }),
        queryClient.invalidateQueries({ queryKey: ['learningHubModuleList'] }),
        queryClient.invalidateQueries({ queryKey: ['adminModuleV2', moduleId] }),
      ]);
      await callbacks?.onSuccess?.();
    },
    onSettled: callbacks?.onSettled,
  });
};
